import { filterMedia } from "./mediaContext"
import { getAccessToken } from "../../services/authService"
import { newRequestId } from "./videoApi"

// Premium Video requests. The server checks and deducts Premium Credits; the browser never sets a price.
const call = async (path, init = {}) => {
  const token = getAccessToken()
  if (!token) throw new Error("Please sign in again.")
  const response = await fetch(`${process.env.REACT_APP_DEV_API}${path}`, { ...init, headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}`, ...(init.headers || {}) } })
  const data = await response.json().catch(() => ({}))
  if (!response.ok) throw new Error(data.message || "Something went wrong. Please try again.")
  return data
}

export const getPremiumAccess = () => call("/ai/premium-video/access")
export const startPremiumVideo = (request) => call("/ai/premium-video", { method: "POST", body: JSON.stringify({ ...request, requestId: request.requestId || newRequestId() }) }).then((d) => d.video)
export const listPremiumVideos = (scriptId) => call(`/ai/premium-videos${scriptId ? `?scriptId=${encodeURIComponent(scriptId)}` : ""}`).then((d) => filterMedia(d.videos || [], scriptId))
export const getPremiumVideo = (id) => call(`/ai/premium-video/${id}`).then((d) => d.video)
export const deletePremiumVideo = (id) => call(`/ai/premium-video/${id}`, { method: "DELETE" })
